import PropTypes from 'prop-types';
import React from 'react';

import { Box, Col, Row, Typography } from 'components/AORedesign';

const DetailRow = ({ label, value, onClick, style }) => (
  <Row spacing={2}>
    <Col xs={5}>
      <Typography component="div">
        <Box fontWeight="bold" textAlign="right">
          {label}:
        </Box>
      </Typography>
    </Col>
    <Col xs={7}>
      <Typography onClick={onClick} style={style} color="textSecondary">
        {value}
      </Typography>
    </Col>
  </Row>
);

DetailRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  onClick: PropTypes.func,
  style: PropTypes.object,
};

export default DetailRow;
